"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledDescription = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 13px;\n    font-weight: 300;\n    margin-top: 0;\n    margin-bottom: 2px;\n\n    & p {\n        font-size: 13px;\n        font-weight: 300;\n        margin-top: 0;\n    }\n"])));

var FieldDescription = function FieldDescription(_ref) {
  var value = _ref.value;
  return _react.default.createElement(StyledDescription, null, (0, _htmlReactParser.default)(value));
};

var _default = FieldDescription;
exports.default = _default;